
export default {
  getPlot: state => {
    return state.plot;
  }
}
